import { render } from "./Carousel.vue?vue&type=template&id=65594f42&scoped=true"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"

import "./Carousel.vue?vue&type=style&index=0&id=65594f42&scoped=true&lang=css"

import exportComponent from "/Users/chase-anderson/Documents/dev/personal/western-slope-paragliding/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65594f42"]])

export default __exports__